import React, { useState } from "react";
import { Select } from "antd";


import GraphModal from "../GraphModal";
import ExpandIcon from "../../../assets/svg/expandIcon.svg";
import ConstituencyDataTable from "./constituencyDataTable";
// import AgeChart from "./ageChart";
import sampleData from "./sampleData.json";
// import AgeVsCommunityChart from "../utils/Charts/ageVsCommunityChart";
// import AgeChart from "../utils/Charts/ageChart";
// import GenderChart from "../utils/Charts/genderChart";
// import CommunityChart from "../utils/Charts/communityChart";
// import GenderVsCommunityChart from "../utils/Charts/genderVsCommunityChart";
import { getGraphData } from "../utils/getFromattedValue";
// import AgeVsGenderChart from "../utils/Charts/ageVsGenderChart";
import { renderCharts } from "../utils/renderCharts";
import { useTranslation } from "react-i18next";

const ConstituencyInformation = ({
  summaryData,
  constituencyDataList,
  isDataAvailable,
  isLoading,
  constituencyDataType
}) => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState("age");
  const openModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };
  //graphData for age VS Gender
  const handleSelectChange = (value) => {
    setSelectedOption(value);
  };
  // const graphData = getGraphData(selectedOption, sampleData);
  const graphData = getGraphData(
    selectedOption,
    sampleData,
    constituencyDataList
  );

  return (
    <>
      <div className="relative">
        {/* Section Header */}
        <div className="flex justify-center items-center mb-4">
          <h3 className="text-3xl font-bold text-gray-800">
            {constituencyDataType==='state' && t("Assembly Data")}
            {constituencyDataType==='central' && t("Parliamentary Data")}
          </h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* Form 20 Data Table */}
          <ConstituencyDataTable
            isDataAvailable={isDataAvailable}
            data={constituencyDataList?.electoralData}
            constituencyLoading={isLoading}
            constituencyDataType={constituencyDataType}
          />

          {/* Electoral Data Chart */}
          <div className="flex flex-col shadow-[0_4px_16px_0_rgba(31,38,135,0.15)] transition-all duration-300 transform hover:shadow-[0_6px_24px_0_rgba(31,38,135,0.25)] hover:scale-[1.01] text-black p-5 relative overflow-hidden rounded-3xl border border-white/30 backdrop-blur-3xl bg-gradient-to-br from-blue-50 via-yellow-100/20 to-emerald-50">
            {/* Animated background elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
              <div className="absolute -top-1/4 -left-1/4 w-1/2 h-1/2 bg-gradient-to-br from-blue-400/10 to-transparent rounded-full blur-2xl animate-pulse"></div>
              <div 
                className="absolute -bottom-1/4 -right-1/4 w-1/2 h-1/2 bg-gradient-to-tl from-purple-400/10 to-transparent rounded-full blur-2xl animate-pulse"
                style={{ animationDelay: "1s" }}
              ></div>
            </div>

            <div className="flex justify-between items-center mb-2 relative z-10">
              <h4 className="text-lg font-bold text-black">
                {constituencyDataType==='state' && t("Assembly Electoral Data")}
                {constituencyDataType==='central' && t("Parliamentary Electoral Data")}
              </h4>
              
              <div className="flex items-center gap-3">
                <Select
                  placeholder="Select Data Type"
                  value={selectedOption}
                  onChange={handleSelectChange}
                  disabled={!isDataAvailable}
                  className="min-w-[140px] modern-select"
                  size="middle"
                  style={{ 
                    height: 36,
                  }}
                  dropdownStyle={{
                    background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(12px)',
                    borderRadius: '12px',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.2)'
                  }}
                >
                  <Select.Option value="age">{t("age")}</Select.Option>
                  <Select.Option value="gender">{t("gender")}</Select.Option>
                  <Select.Option value="ageGender">{t("ageVsGender")}</Select.Option>
                  <Select.Option value="community">{t("community")}</Select.Option>
                </Select>
                <button 
                    onClick={openModal}
                    className="p-2.5 hover:bg-white/30 rounded-xl transition-all duration-200 backdrop-blur-sm border border-white/20 shadow-lg hover:shadow-xl hover:scale-105 bg-white/20"
                    disabled={!isDataAvailable || selectedOption === "community"}

                  >
                  <img src={ExpandIcon} alt="expand" className="w-4 h-4 opacity-80" />
                </button>
              </div>
            </div>
            
            <div className="flex-1 relative z-10 bg-gray-400/10 backdrop-blur-sm rounded-2xl px-4 border border-white/20">
              {renderCharts(selectedOption, isDataAvailable, graphData, isLoading)}
            </div>
          </div>
        </div>

        {/* Graph Modal */}
        <GraphModal
          isDataAvailable={isDataAvailable}
          isModalVisible={isModalVisible}
          closeModal={closeModal}
          graphData={graphData}
          selectedOption={selectedOption}
        />
      </div>
    </>
  );
};

export default ConstituencyInformation;
